var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.88,
    height: 110.88,
    viewBox: "0 0 110.88 110.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f37320;}.b{fill:#e2e2e2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M124.085,113.675h0a3.992,3.992,0,0,1-3.065-1.393L99.987,89.438a4.142,4.142,0,1,1,6.129-5.572l18.109,19.641L174.371,53.5a4.039,4.039,0,0,1,5.85,0,4.161,4.161,0,0,1,0,5.851L127.01,112.422A3.794,3.794,0,0,1,124.085,113.675Z",
    transform: "translate(-72.545 -38.316)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.44,110.88A55.44,55.44,0,1,1,55.44,0a4.1,4.1,0,0,1,4.179,4.179A4.1,4.1,0,0,1,55.44,8.358,47.082,47.082,0,1,0,102.523,55.44a4.179,4.179,0,1,1,8.358,0A55.585,55.585,0,0,1,55.44,110.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1440287326930383a9f4c52da501c8ef.svg";
export { ForwardRef as ReactComponent };